import {Controller} from "stimulus";
import {
    makeKarrotBridge,
    installKarrotBridgeDriver,
} from "@daangn/karrotbridge";
import { MockAppInfo, MockUserInfo } from "utils/mock";

export default class extends Controller {
    static targets = ["container", "progress"];
    static values = {
        appInfo: Object, // const { appVersionCode, appVersion, locale, userAgent, country, appHost, deviceIdentity } = appInfo.info.app;
        userInfo: Object
    };

    initialize() {
        this.bridge = null;
        this.keepLoading = false; // 계속 로딩으로 놔두고 싶을 때
    }

    get requestHeader() {
        return {
            "X-Auth-Token": this.userInfoValue.authToken,
            "X-User-Agent": this.appInfoValue.userAgent
        }
    }

    getAppInfo() {
        if (process.env.NODE_ENV === "development") {
            return new Promise((resolve) =>
                setTimeout(() => {
                    resolve(MockAppInfo);
                }, 500)
            );
        }

        return this.bridge.getAppInfo({})
    }

    getUserInfo() {
        if (process.env.NODE_ENV === "development") {
            return new Promise((resolve) =>
                setTimeout(() => {
                    resolve(MockUserInfo);
                }, 500)
            );
        }

        return this.bridge.getUserInfo({})
    }

    closeAndRedirect(redirectUrl) {
        this.keepLoading = true;
        window.location.href = redirectUrl;
        this.bridge.closeRouter();
    }

    // 최종으로 로딩을 끝내고 로딩바 제거하려면 어디에서든간에 이 함수 호출 해야함
    // this.karrotBridgeController.loadingCompleted();
    loadingCompleted() {
        if (this.keepLoading) {
            return;
        }

        this.progressTarget.remove();
        this.containerTarget.classList.remove("hidden")
    }

    async prepareAppInfo() {
        const userResponse = await this.getUserInfo();
        const appResponse = await this.getAppInfo();
        this.userInfoValue = userResponse.info.user;
        this.appInfoValue = appResponse.info.app;

        const customEvent = new CustomEvent('karrot-bridge:load', { detail: { app: this.appInfoValue, user: this.userInfoValue } });
        document.dispatchEvent(customEvent);
    }

    connect() {
        const {driver} = installKarrotBridgeDriver();
        this.bridge = makeKarrotBridge({driver});
        this.prepareAppInfo();
    }

    disconnect() {
        this.bridge.uninstall();
    }
}
